import Image from 'next/image';
import { Button } from '@savvy-kit/components/button';
import { ArrowUpRight } from 'lucide-react';

export function MarketingSwagStoreCard() {
  return (
    <a
      href="https://savvy.bluemark.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="block rounded-md border border-light overflow-hidden hover:bg-component-hover transition-colors"
    >
      <div className="relative bg-green-700 h-[180px] flex items-center justify-center p-6 overflow-hidden">
        <Image
          src="/marketing/swag-cap.png"
          alt="Savvy branded cap"
          width={1044}
          height={982}
          className="h-28 w-auto object-contain rounded-lg border-[3px] border-black/50"
        />
      </div>
      <div className="p-4 bg-white">
        <p className="text-[10.5px] font-semibold uppercase tracking-[0.15em] text-amber-600 mb-1">Savvy Swag Store</p>
        <h4 className="text-base font-semibold leading-tight tracking-tight">Branded gear for you and your clients</h4>
        <p className="text-xs text-secondary mt-1.5 leading-snug">
          Quarter-zips, notebooks, mugs, and totes — shipped anywhere in the US.
        </p>
        <Button className="mt-3 w-full" size="sm">
          Shop the store <ArrowUpRight className="size-3.5" />
        </Button>
      </div>
    </a>
  );
}
